import monkeyImage from 'assets/monkey-surprised.svg';
import React from 'react';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import BasicModalTemplate from '../BasicModalTemplate';
import { ModalInstanceProps } from '../interfaces';
import './ChatbotLimitModal.pcss';

const HEADER_TEXT = 'Chatbot Limit Reached';

type Props = ModalInstanceProps & {
  bodyText: string;
  title?: string;
};

export const MonkeyOopsTemplate = ({
  title,
  bodyText,
  closeButtonText,
  onClose,
}: Omit<Props, 'closeModal'> & {
  closeButtonText: string;
  onClose: () => void;
  onUpgradeButtonClick?: () => void;
  upgradeButtonText?: string;
}) => {
  return (
    <BasicModalTemplate
      className="chatbot-limit-modal"
      withMonkeyBackground={false}
    >
      <img
        alt="Monkey Logo"
        src={monkeyImage}
        className="chatbot-limit-modal__monkey-image"
      />

      <div className="chatbot-limit-modal__right-section">
        <div className="chatbot-limit-modal__header-text">{title}</div>

        <div className="chatbot-limit-modal__text">{bodyText}</div>

        <div className="chatbot-limit-modal__buttons-wrapper">
          <Button invert onClick={onClose}>
            {closeButtonText}
          </Button>
        </div>
      </div>
    </BasicModalTemplate>
  );
};

export const ChatbotLimitModal = (props: Props) => {
  const { closeModal, bodyText, title } = props;

  return (
    <MonkeyOopsTemplate
      closeButtonText="Cancel"
      bodyText={bodyText}
      title={title ? title : HEADER_TEXT}
      onClose={closeModal}
    />
  );
};
